// // // //

// NOTE - sourced from .notes/product-segmentation.md (App Pages, Downloads, Charts, API). The
// login drawer lists the Free Preview tier; the unlock + upgrade drawers list Pro. Kept as separate
// arrays so each drawer's benefits can be tuned independently

/**
 * LOGIN_TO_UNLOCK_DRAWER_BENEFITS
 * Benefits listed in the footer of the LoginToUnlockDrawer
 */
export const LOGIN_TO_UNLOCK_DRAWER_BENEFITS: string[] = [
    "25 complete page views per-month",
    "Unlimited downloads of preview data",
    "Custom charts",
    // "API access with 10 requests per month",
];

/**
 * UNLOCK_PAGE_DRAWER_BENEFITS
 * Benefits listed in the footer of the UnlockPageDrawer
 */
export const UNLOCK_PAGE_DRAWER_BENEFITS: string[] = [
    "Unlimited page views",
    "Full downloads for all assets, platforms, networks, and managers",
    "Unlimited custom charts",
    // "Full API schema and endpoints",
];

/**
 * UPGRADE_TO_UNLOCK_DRAWER_BENEFITS
 * Benefits listed in the footer of the UpgradeToUnlockDrawer
 */
export const UPGRADE_TO_UNLOCK_DRAWER_BENEFITS: string[] = [
    "Unlimited page views",
    "Full downloads for all assets, platforms, networks, and managers",
    "Unlimited custom charts",
    // "Full API schema and endpoints",
];
